module.exports = "/components/components/salesInlineEditComponent-8a8021.html";